import { render, staticRenderFns } from "./payment-card.vue?vue&type=template&id=39d1f542&scoped=true&"
import script from "./payment-card.vue?vue&type=script&lang=js&"
export * from "./payment-card.vue?vue&type=script&lang=js&"
import style0 from "./payment-card.vue?vue&type=style&index=0&id=39d1f542&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d1f542",
  null
  
)

export default component.exports